
import {
  Component, Mixins,
} from 'vue-property-decorator';
import TaskEditDialog from '@/components/TaskEditDialog.vue';
import DialogMixin from '@/mixins/DialogMixin.vue';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import TaskMixin from '@/mixins/TaskMixin.vue';
import { getLeadCustomValueText } from '@/helpers';

@Component({
  components: {
    TaskEditDialog,
  },
})
export default class EditLeadPodDialog extends Mixins(DialogMixin, UtilsMixin, TaskMixin) {
  pod: string | null = null

  // Aggiorna i campi con gli eventuali nuovi valori della Lead selezionata
  refreshTask() {
    console.log(`${this.constructor.name}: refreshTask()`); // eslint-disable-line no-console

    this.pod = getLeadCustomValueText(this.selectedLead, 'pod') ?? null;

    // Richiama il metodo implementato nel mixin
    return this.mixinRefreshTask();
  }

  get podRequiredRules() { return this.podRules(this.pod); }

  podAlert(pod: string | null) {
    // ritorna true se il codice POD inizia con la stringa it002e
    return pod !== null ? pod.replace(/ /g, '').toLowerCase().startsWith('it002e') || false : false;
  }
}
